/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { GoToJoinHeading } from '../../../components/Headings/GoToJoinHeading';
import { NativeJoinButton } from '../../../components/Buttons/NativeJoinButton';
import { defineMessages, useIntl } from 'react-intl';
import { Spacing } from '../../../themes/GoToTheme';
import { Flex } from '@getgo/chameleon-chakra-ui';
import { GoToCaption } from '../../../components/Texts/GoToCaption';
import { FirstJoinPageProps } from './GoToFirstJoin';

const messages = defineMessages({
  heading: {
    id: 'goto.join.heading.desktopOnlyCaption',
  },
  buttonCaption: {
    id: 'goto.join.button.native.caption',
  },
});

export const GoToFirstJoinDesktopOnly: React.FC<FirstJoinPageProps> = ({
  onStartButtonClick,
}) => {
  const { formatMessage: f } = useIntl();
  return (
    <>
      <GoToJoinHeading greeting heading={f(messages.heading)} />
      <Flex
        marginBottom={Spacing.CoreLayout4}
        minWidth='min-content'
        alignItems='center'
      >
        <NativeJoinButton
          firstJoin
          marginRight={Spacing.CoreLayout2}
          onStartButtonClick={onStartButtonClick}
        />
        <GoToCaption>{f(messages.buttonCaption)}</GoToCaption>
      </Flex>
    </>
  );
};
